import {hrmsWithPath} from "../../services/http/api/rest";

const rest = hrmsWithPath('/v1/event')
const event = {
    list: (data: any) => rest.get('', {}, data),
    update: (id: string, data: any) => rest.put('/{{id}}', {id}, data, {}),
    create: (data: any) => rest.post('', {}, data, {}),
    edit: (id: string, data: any) => rest.put('/{{id}}', {}, data),
    delete: (id: string) => rest.del('/{{id}}', {id},),
    upload: (id: string, documents: string[]) => rest.post('/{{id}}/photos', {id}, documents),
    getPhotos: (id: string, pageSize?: number, pageNumber?: number) => rest.get('/{{id}}/photos', {id},
        {
            'page-size': pageSize,
            'page-number': pageNumber
        }),
    cancel: (eventId: string,reason:string) => rest.put('/{{eventId}}/cancel', {eventId},{},{reason},{"Content-Type": "application/json"}),
    getById: (id: string) => rest.get('/{{id}}', {id},),
}

export default event;